import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Family.module.css';

const Family: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          ← 返回
        </button>
        <h1 className={styles.title}>家庭共学</h1>
        <p className={styles.subtitle}>让全家用同一套方法，一起学会照顾宝宝</p>
      </header>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>为什么要全家一起学？</h2>
        <div className={styles.reasonList}>
          <div className={styles.reasonItem}>
            <span className={styles.reasonIcon}>🤝</span>
            <div>
              <h3>统一育儿方法</h3>
              <p>避免"妈妈说这样，奶奶说那样"的分歧，全家使用同一套知识体系。</p>
            </div>
          </div>
          <div className={styles.reasonItem}>
            <span className={styles.reasonIcon}>👨‍👩‍👧</span>
            <div>
              <h3>分担照护压力</h3>
              <p>爸爸、祖辈共同学习，关键时刻每个人都能做出正确判断。</p>
            </div>
          </div>
          <div className={styles.reasonItem}>
            <span className={styles.reasonIcon}>🛡️</span>
            <div>
              <h3>减少安全隐患</h3>
              <p>每个照护者都掌握安全知识，降低因经验不足导致的风险。</p>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>共学建议</h2>
        <ul className={styles.tips}>
          <li>爸爸和妈妈一起完成每关的学习和答题</li>
          <li>与祖辈分享知识卡片中的常见误区</li>
          <li>每周一次家庭共学时间，讨论本周学到的内容</li>
          <li>重点安全关卡建议所有照护者都完成</li>
        </ul>
      </section>

      <div className={styles.comingSoon}>
        <div className={styles.comingIcon}>🚀</div>
        <h3>后续功能预告</h3>
        <p>完成后将上线家庭空间功能，支持：</p>
        <ul>
          <li>邀请家人加入学习</li>
          <li>查看家庭成员的掌握情况</li>
          <li>家庭薄弱模块提醒</li>
          <li>家庭共学建议推送</li>
        </ul>
      </div>

      <button className={styles.backToLearn} onClick={() => navigate('/map')}>
        返回继续学习
      </button>
    </div>
  );
};

export default Family;